var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-row",
    [
      _c("v-col", { staticClass: "pa-0 mt-n3" }, [
        _c(
          "a",
          { attrs: { href: "#", tite: "", alt: "" } },
          [
            _c("BaseImage", {
              attrs: { mobileSrc: _vm.mobileSrc, desktopSrc: _vm.desktopSrc },
            }),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }